import { createSelector } from 'reselect';
import { RootState } from '../interfaces';
import { pluck, flatten } from '../util/general';
// import { IAppSettingsState } from '../reducers';

// import { SettingsModel } from '../models';
export const membershipCards = (state:RootState) => state.appSettings.config.membershipCards;

export const notifications = (state:RootState) => state.appSettings.config.notifications;

export const countries = (state: RootState) => state.appSettings.config.countries;

export const phoneCountryCodes = createSelector(
  countries,
  (countries) => flatten(pluck('phoneCountryCodes')(countries))
)
